export default {
  title: 'Attiva il tuo abbonamento',
  title_confirm: 'Conferma il tuo piano',
  step: 'Passo {{current}} di {{total}}',
  subtitle: '{{name}} · 1 sede',
  trial_badge: '{{days}} giorni gratis',
  trial_headline: 'Primi {{days}} giorni gratis',
  then_price: 'Poi {{price}} / mese per sede · IVA inclusa se applicabile',
  price_per_month: '{{price}} / mese',
  price_terms: 'Per sede, fatturato mensilmente · IVA inclusa se applicabile',
  tier_upsell:
    'Raggiungi {{threshold}}+ sedi attive e la tariffa per tutte le tue sedi scende a {{price}} / mese per sede, in automatico.',
  tier_active: 'Tariffa a volume — {{threshold}}+ sedi attive',
  due_today: 'Dovuto oggi',
  from_date: 'Dal {{date}}',
  no_charge_today: 'Nessun addebito oggi.',
  no_charge_until: 'Oggi non ti verrà addebitato nulla. Annulla entro il {{date}} e non pagherai nulla.',
  active: '{{plan}} è attivo per questo ristorante.',
  active_with_trial: '{{plan}} è attivo per questo ristorante, gratuito fino al {{date}}.',
  terms:
    'Accetto i <a href="{{terms_url}}" target="_blank" rel="noreferrer">Termini della piattaforma partner FoodAmigos</a>, incluse attivazione, cancellazione e rimborsi.',
  error: "Non è stato possibile completare l'acquisto. Riprova.",
  loading: 'Verifica del piano di questo ristorante…',
  load_error: 'Non è stato possibile verificare il piano di questo ristorante.',
  unavailable: 'Questo prodotto non è disponibile per questo ristorante. Contatta il tuo account manager FoodAmigos.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Ordini online',
          description: 'Ordini diretti sul sito con marchio del ristorante',
        },
        reservations: {
          title: 'Prenotazioni tavoli',
          description: 'Gli ospiti prenotano un tavolo direttamente online',
        },
        marketing: {
          title: 'Marketing Suite',
          description: 'Offer Builder, programma fedeltà a punti e risposte AI alle recensioni Google',
        },
        pricing: {
          title: '0% di commissioni, nessun costo di attivazione',
          description: 'Una licenza per sede, fatturata mensilmente',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: "L'app con il marchio del ristorante",
          description: 'Su App Store e Google Play',
        },
        engagement: {
          title: 'Notifiche push e fedeltà',
          description: 'Fai tornare gli ospiti con offerte e punti',
        },
        ordering: {
          title: 'Ordini a commissione 0%',
          description: "Ordini diretti dall'app",
        },
        apple: {
          title: 'Account Apple Developer richiesto',
          description: "99$/anno, pagati ad Apple, tramite l'entità legale del ristorante",
        },
      },
    },
    ai_website: {
      title: 'Abbonamento Website Builder',
      subtitle_domain: 'Metti online il sito di {{name}} su {{domain}}',
      features: {
        domain: {
          title: 'Il tuo sito, online sul tuo dominio',
          description: 'Il sito web con il marchio del ristorante',
        },
        ai: {
          title: "Creato e aggiornato con l'AI",
          description: 'Crea pagine, testi e immagini per il ristorante in pochi minuti',
        },
        ordering: {
          title: 'Ordini e prenotazioni integrati',
          description: 'Gli ospiti ordinano e prenotano un tavolo direttamente dal sito',
        },
        pricing: {
          title: 'Nessun costo di attivazione',
          description: 'Una licenza per sede, fatturata mensilmente',
        },
      },
    },
    storefront: {
      title: 'Abbonamento Website Builder',
      subtitle_domain: 'Metti online il sito di {{name}} su {{domain}}',
      features: {
        domain: {
          title: 'Il tuo sito, online sul tuo dominio',
          description: 'Il sito web con il marchio del ristorante',
        },
        ai: {
          title: "Creato e aggiornato con l'AI",
          description: 'Crea pagine, testi e immagini per il ristorante in pochi minuti',
        },
        ordering: {
          title: 'Ordini e prenotazioni integrati',
          description: 'Gli ospiti ordinano e prenotano un tavolo direttamente dal sito',
        },
        pricing: {
          title: 'Nessun costo di attivazione',
          description: 'Una licenza per sede, fatturata mensilmente',
        },
      },
    },
  },
  payment_method: {
    label: 'Il tuo metodo di pagamento partner',
    on_file: 'Carta registrata',
    pending_title: 'Conferma del metodo di pagamento in corso',
    pending: 'Stripe sta ancora confermando la carta appena aggiunta. Potrebbe richiedere un minuto.',
    still_pending: 'Non ancora pronto. Aspetta un momento e riprova.',
    error: 'Impossibile aprire il modulo di pagamento. Riprova.',
  },
  buttons: {
    close: 'Chiudi',
    continue_to_payment: 'Procedi al pagamento',
    start_trial: 'Avvia prova gratuita di {{days}} giorni',
    subscribe: 'Avvia abbonamento',
    continue: 'Continua',
    change: 'Cambia',
    retry: 'Riprova',
    check_again: 'Controlla di nuovo',
    add_again: 'Aggiungi di nuovo una carta',
  },
};
